export const componentsPublishedEventBody = ({ producerId, productId, type, templatePayload }) => {
  const eventBody = {
    producerId,
    productId,
    type,
    date: new Date(),
    components: componentsCounts(templatePayload)
  }
  return eventBody
}

export const saveBuilderWithoutMobileEventBody = ({ producerId, productId }) => {
  const eventBody = {
    producerId,
    productId,
    date: new Date()
  }
  return eventBody
}

export const dropOffConfigEventBody = ({ producerId, productId, type, lastComponent }) => {
  const eventBody = {
    producerId,
    productId,
    date: new Date(),
    type, // (fechou a tela ou saiu sem salvar / mobile ou desktop)
    lastComponent
  }
  return eventBody
}

export const changeProductEventBody = ({ producerId, newProductId, oldProductId }) => {
  const eventBody = {
    producerId,
    newProductId,
    oldProductId,
    date: new Date()
  }
  return eventBody
}

export const saveCheckoutEventBody = ({ producerId, productId, checkoutId }) => {
  const eventBody = {
    producerId,
    productId,
    checkoutId,
    date: new Date()
  }
  return eventBody
}

export const basicInfoEventBody = ({ producerId, productId }) => {
  const eventBody = {
    producerId,
    productId,
    date: new Date()
  }
  return eventBody
}

function componentsCounts (templatePayload) {
  const results = generateCountArray(mapCustomCheckoutPayloadComponentNames(templatePayload).map(componentName => kebabCaseToCamelCase(componentName)))

  return {
    hotpayAdvantages: 0,
    hotpayBadges: 0,
    hotpayCountdown: 0,
    hotpayFacebook: 0,
    hotpayHeader: 0,
    hotpayImage: 0,
    hotpayLine: 0,
    hotpayList: 0,
    hotpayMap: 0,
    hotpayReviews: 0,
    hotpayText: 0,
    hotpayVideo: 0,
    hotpayOrderBump: 0,
    ...results
  }
}

function flatDeep (arr, d = 1) {
  return d > 0 ? arr.reduce((acc, val) => acc.concat(Array.isArray(val) ? flatDeep(val, d - 1) : val), []) : arr.slice()
}

function mapCustomCheckoutPayloadComponentNames (customCheckoutPayload) {
  if (customCheckoutPayload) {
    const componentNamesArray = flatDeep(JSON.parse(customCheckoutPayload).rows.map(row => (row.columns.map(column => (column.components.map(component => (component.name)))))), 2).filter(component => component !== 'hotpay-checkout')

    return componentNamesArray
  }
  return []
}

function generateCountArray (keys) {
  const result = {}
  keys.map(key => {
    result[key] ? result[key]++ : result[key] = 1
  })
  return result
}

function kebabCaseToCamelCase (words) {
  const splitedWords = words.split('-')
  if (splitedWords.length === 1) return words
  const toCamelCase = splitedWords.map((word, index) => {
    if (index > 0) {
      let splitedWord = word.split('')
      splitedWord[0] = splitedWord[0].toUpperCase()
      splitedWord = splitedWord.join('')
      return splitedWord
    }
    return word
  }).join('')
  return toCamelCase
}
